import React from "react";
import PropTypes from "prop-types";
import ErrorOutlineOutlinedIcon from "@mui/icons-material/ErrorOutlineOutlined";
import { Typography } from "@mui/material";
import { useSelector } from "react-redux";

import messages from "../../../assets/locale/messages";
import { UIButton, UIModal } from "../../ui";

import "./RemoveModal.scss";

const RemoveModal = ({
  open,
  onClose,
  onConfirm,
  title,
  message,
  confirmLabel,
  confirmDisabled,
}) => {
  const lang = useSelector((state) => state.locale.lang);
  const { shared } = messages[lang];

  return (
    <UIModal
      className="remove-modal"
      open={open}
      onClose={onClose}
      title={null}
      showClose={false}
      actions={
        <>
          <UIButton
            variant="outlined"
            onClick={onClose}
            type="button"
            color="inherit"
          >
            {shared.cancel}
          </UIButton>
          <UIButton
            color="error"
            disabled={confirmDisabled}
            onClick={onConfirm}
            type="button"
          >
            {confirmLabel}
          </UIButton>
        </>
      }
    >
      <div className="remove-modal__content">
        <div className="remove-modal__icon">
          <ErrorOutlineOutlinedIcon
            sx={{ fontSize: 30, color: "var(--color-error-500)" }}
          />
        </div>
        <Typography
          className="remove-modal__title text-heading-md"
          component="h2"
        >
          {title}
        </Typography>
        <Typography
          className="remove-modal__message text-body-sm"
          component="p"
        >
          {message}
        </Typography>
      </div>
    </UIModal>
  );
};

RemoveModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  message: PropTypes.string.isRequired,
  confirmLabel: PropTypes.string.isRequired,
  confirmDisabled: PropTypes.bool,
};

RemoveModal.defaultProps = {
  confirmDisabled: false,
};

export default RemoveModal;
